import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadAdminGuard } from '@app/core';
import { AnalyticsDashboardComponent } from './components/analytics-dashboard/analytics-dashboard.component';
import { HyperpureCartIframeComponent } from './components/hyperpure-cart-iframe/hyperpure-cart-iframe.component';
import { PmLandingComponent } from './components/pm-landing/pm-landing.component';
import { PmOrdersComponent } from './components/pm-orders/pm-orders.component';
import { PmPriceDiscoveryDirectComponent } from './components/pm-price-discovery-direct/pm-price-discovery-direct.component';
import { PmPriceDiscoveryComponent } from './components/pm-price-discovery/pm-price-discovery.component';
import { PmSuppliersComponent } from './components/pm-suppliers/pm-suppliers.component';

const routes: Routes = [
    {
        path: '',
        component: PmLandingComponent,
        data: { title: 'Purchase Manager', breadcrumb: 'Purchase Manager' }
    },
    {
        path: 'price-discovery',
        component: PmPriceDiscoveryComponent,
        data: { title: 'Price Discovery', breadcrumb: 'Price Discovery' }
    },
    {
        path: 'price-discovery-direct',
        component: PmPriceDiscoveryDirectComponent,
        data: { title: 'Price Discovery Direct', breadcrumb: 'Price Discovery Direct' }
    },
    {
        path: 'orders',
        component: PmOrdersComponent,
        data: { title: 'Orders' }
    },
    {
        path: 'suppliers',
        component: PmSuppliersComponent,
        data: { title: 'Suppliers' }
    },
    // {
    //     path: 'analytics',
    //     component: PmAnalyticsDashboardComponent,
    //     canActivate: [LeadAdminGuard],
    //     data: { title: 'Analytics', breadcrumb: 'Analytics' }
    // },
    {
        path: 'hyperpure-cart',
        component: HyperpureCartIframeComponent,
        data: { title: 'Hyperpure Cart', breadcrumb: 'Hyperpure Cart' }
    },
    {
        path: 'analytics',
        component: AnalyticsDashboardComponent,
        canActivate: [LeadAdminGuard],
        data: { title: 'Analytics', breadcrumb: 'Analytics' }
    }
];

/**
 * Handles the routing configuration for the Purchase Manager module.
 * Routes include the landing page, price discovery, orders, and suppliers.
 */
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PurchaseManagerRoutingModule { }
